// removed by extract-text-webpack-plugin
module.exports = {"text":"text__2RsX9","rect":"rect__3uHGJ","img":"img__3bgZy","sdgImage":"sdgImage__27RRm","sdgCircle":"sdgCircle__3hk4H","toolTip":"toolTip__1CWCM","head":"head__15F0H","sdgWrapper":"sdgWrapper__X5tOt","backButtonContainer":"backButtonContainer__3Awkg","backButton":"backButton__1fkMa","backImg":"backImg__1YqL0","embedArray":"embedArray__2u4R0","leftArray":"leftArray__MAZLU","rightArray":"rightArray__YMyDS","svgIe":"svgIe__2s1Vl"};


//////////////////
// WEBPACK FOOTER
// ./components/sunburstChart/style.scss
// module id = UhRM
// module chunks = 0